<div class="h-full-dynamic">
	<ejs-grid
		#grid
		height="100%"
		width="100%"
		[dataSource]="data | async"
		[allowReordering]="true"
		[allowPaging]="true"
		[pageSettings]="pageOptions"
		[filterSettings]="filterSettings"
		[loadingIndicator]="loadingIndicator"
		[contextMenuItems]="contextMenuItems"
		[columnMenuItems]="columnMenuItems"
		[toolbar]="toolbar"
		[allowFiltering]="true"
		[allowSorting]="true"
		[allowGrouping]="isAllowGrouping"
		[showColumnChooser]="true"
		[allowPdfExport]="true"
		[allowExcelExport]="true"
		[allowResizing]="true"
		[allowSelection]="true"
		[enableHover]="true"
		[selectionSettings]="selectionSettings"
		[columnChooserSettings]="columnChooserSettings"
		[enableVirtualization]="table.enableVirtualization"
		gridLines="Both"
		(dataStateChange)="dataStateChange($event)"
		(load)="dataLoad()"
		(dataBound)="dataBound()"
		(toolbarClick)="onToolbarClick($event)">
		<e-columns>
			@if (table.actions.update || table.actions.delete || table.actions.read) {
				<e-column
					[width]="table.actions.width"
					[allowResizing]="false"
					[allowReordering]="false"
					textAlign="center"
					[customAttributes]="{ class: 'nofocus' }">
					<ng-template #template let-data>
						@if (table.actions.update && table.privelege?.edit) {
							<ms-button
								icon="fas fa-pencil"
								[noPadding]="true"
								variant="text"
								severity="secondary"
								(click)="table.actions.update(data)" />
						}
						@if (table.actions.delete && table.privelege?.delete) {
							<ms-button
								icon="fas fa-trash"
								[noPadding]="true"
								variant="text"
								severity="secondary"
								(click)="table.actions.delete(data)" />
						}
						@if (table.actions.read && table.privelege?.view) {
							<ms-button
								icon="fas fa-file-search"
								[noPadding]="true"
								variant="text"
								severity="secondary"
								(click)="table.actions.read(data)" />
						}
					</ng-template>
				</e-column>
			}
			<ng-container *ngFor="let column of table.columns">
				<e-column
					[field]="column.field"
					[headerText]="column.header"
					[textAlign]="column.field === 'id' ? 'center' : null"
					[autoFit]="true"
					[filter]="
						column.type !== 'number' &&
						column.type !== 'boolean' &&
						column.type !== 'date' &&
						column.type !== 'datetime'
							? { operator: 'contains' }
							: {}
					"
					[customAttributes]="{ class: 'nofocus' }">
					<ng-template #template let-data>
						@if (column.type === 'string') {
							{{ parseDataToValue.parse(data, column.field) }}
						}
						@if (column.type === 'boolean') {
							<ms-input-switch
								[value]="data[column.field]"
								[onChange]="column.onAction"
								[data]="data"></ms-input-switch>
						}
						@if (column.type === 'number') {
							{{ parseDataToValue.parse(data, column.field) }}
						}
						@if (column.type === 'date') {
							no-implemented (date)
						}
						@if (column.type === 'datetime') {
							no-implemented (datetime)
						}
					</ng-template>
					<ng-template #filterTemplate let-data>
						@if (column.type === 'string') {
							<ejs-textbox [value]="data.value"></ejs-textbox>
						}
						@if (column.type === 'boolean') {
							<ejs-dropdownlist
								[value]="data.value"
								[fields]="{ text: 'text', value: 'value' }"
								[dataSource]="[
									{ text: 'Ativo', value: 'true' },
									{ text: 'Inativo', value: 'false' },
								]"></ejs-dropdownlist>
						}
						@if (column.type === 'number') {
							<ejs-numerictextbox [value]="data.value"></ejs-numerictextbox>
						}
						@if (column.type === 'date') {
							no-implemented (date)
						}
						@if (column.type === 'datetime') {
							no-implemented (datetime)
						}
					</ng-template>
				</e-column>
			</ng-container>
		</e-columns>
	</ejs-grid>
</div>
